export default __webpack_public_path__ + "static/media/004-anchor-2.0113efed.png";